import { render, staticRenderFns } from "./QuoteIcon.vue?vue&type=template&id=4f38047b&scoped=true"
import script from "./QuoteIcon.vue?vue&type=script&lang=js"
export * from "./QuoteIcon.vue?vue&type=script&lang=js"
import style0 from "./QuoteIcon.vue?vue&type=style&index=0&id=4f38047b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f38047b",
  null
  
)

export default component.exports